import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'mc-delete-site-dialog',
  templateUrl: './delete-site-dialog.component.html',
  styleUrls: ['./delete-site-dialog.component.scss'],
})
export class DeleteSiteDialogComponent implements OnInit {
  siteUrl: string;
  isSiteHaveSubscription: boolean;
  constructor(
    public dialogRef: MatDialogRef<DeleteSiteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data?: {siteUrl: string; isSiteHaveSubscription: boolean},
  ) {}

  ngOnInit(): void {
    this.siteUrl = this.data.siteUrl;
    this.isSiteHaveSubscription = this.data.isSiteHaveSubscription;
  }

  confirm() {
    this.dialogRef.close({confirm: true});
  }

  close(): void {
    this.dialogRef.close({confirm: false});
  }
}
